export default function DollarSignSVG() {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      {/* prettier-ignore */}
      <path d="M8.33313 0C3.73313 0 0 3.73313 0 8.33313C0 12.9331 3.73313 16.6663 8.33313 16.6663C12.9331 16.6663 16.6663 12.9331 16.6663 8.33313C16.6663 3.73313 12.9331 0 8.33313 0ZM8.33313 15C4.65813 15 1.66625 12.0081 1.66625 8.33313C1.66625 4.65813 4.65813 1.66625 8.33313 1.66625C12.0081 1.66625 15 4.65813 15 8.33313C15 12.0081 12.0081 15 8.33313 15ZM8.59125 7.61625C7.11625 7.24125 6.64125 6.83313 6.64125 6.22438C6.64125 5.52438 7.29938 5.0325 8.39125 5.0325C9.54125 5.0325 9.97438 5.5825 10.0081 6.39938H11.4331C11.3912 5.2825 10.7081 4.2575 9.35812 3.92438V2.49937H7.41625V3.9075C6.15813 4.17437 5.14938 4.99063 5.14938 6.24938C5.14938 7.74125 6.39125 8.49125 8.19938 8.92437C9.82438 9.3075 10.1494 9.8825 10.1494 10.4825C10.1494 10.9244 9.82438 11.6406 8.39938 11.6406C7.06625 11.6406 6.54125 11.0406 6.46625 10.2737H5.03313C5.11625 11.6906 6.16625 12.4906 7.41625 12.7488V14.1656H9.36625V12.7737C10.6331 12.5319 11.6331 11.8069 11.6412 10.4656C11.6331 8.6325 10.0581 7.99937 8.59125 7.61625Z" fill="currentColor"/>
    </svg>
  );
}
